import { Element, animateScroll as scroll, scroller } from 'react-scroll';

export const scrollToElement = (elementName: string, duration = 250, offset = 0, delay = 0) => {
  scroller.scrollTo(elementName, { delay, duration, offset, smooth: true });
};

export const scrollToTop = (options?: object) => {
  scroll.scrollToTop(options);
};

export const scrollTo = (position = 0, duration = 250, offset = 0, delay = 0) => {
  scroll.scrollTo(position, { delay, duration, offset, smooth: true });
};

export const createScrollReference = (name: string) => <Element name={name} />;
